import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { TypeRegister } from 'practice/constants/type-register';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface RequestAssessmentVM {
  request?: boolean;
  note?: string;
  tipoUltimaOperazione?: string;
  scala?: string;
  piano?: string;
  interno?: string;
}

interface AccordionRequestAssessmentFormProps {
  disabled?: boolean;
  values?: RequestAssessmentVM;
  errors?: FormikErrors<RequestAssessmentVM>;
  touched?: FormikTouched<RequestAssessmentVM>;
  hasAttentionNote?: boolean;
  onChange: (
    key: keyof RequestAssessmentVM,
    value: RequestAssessmentVM[keyof RequestAssessmentVM]
  ) => void;
  onChanges: (values: RequestAssessmentVM) => void;
  disabledMessi?: boolean;
  typeRegister?: string;
}

const AccordionRequestAssessmentFormComponent = ({
  values,
  onChange,
  onChanges,
  touched,
  errors,
  hasAttentionNote,
  disabled,
  disabledMessi,
  typeRegister,
}: AccordionRequestAssessmentFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="request"
              checked={values?.request || false}
              onChange={() =>
                onChanges({
                  request: !values?.request,
                  note: '',
                })
              }
              inputProps={{ 'aria-label': 'Richiesta accertamento messi' }}
              disabled={disabled || disabledMessi}
            />
          }
          label="Richiesta accertamento messi"
        />
      </Grid>
      {typeRegister === TypeRegister.Immigration || typeRegister === TypeRegister.Residence ? (
        <>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="scala"
              label="Scala"
              aria-label="Scala"
              fullWidth
              onChange={(event) => {
                onChange('scala', event.target.value);
              }}
              value={values?.scala || ''}
              error={touched?.scala && Boolean(errors?.scala)}
              helperText={errors?.scala}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="piano"
              label="Piano"
              aria-label="Piano"
              fullWidth
              onChange={(event) => {
                onChange('piano', event.target.value);
              }}
              value={values?.piano || ''}
              error={touched?.piano && Boolean(errors?.piano)}
              helperText={errors?.piano}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="interno"
              label="Interno"
              aria-label="Interno"
              fullWidth
              onChange={(event) => {
                onChange('interno', event.target.value);
              }}
              value={values?.interno || ''}
              error={touched?.interno && Boolean(errors?.interno)}
              helperText={errors?.interno}
              disabled={disabled}
            />
          </Grid>
        </>
      ) : undefined}

      <Grid item xs={12}>
        <PmiTextField
          id="note"
          label="Nota per ufficio messi"
          aria-label="Nota per ufficio messi"
          fullWidth
          multiline
          rows={7}
          inputProps={{
            maxLength: '240',
          }}
          onChange={(event) => {
            onChange('note', event.target.value);
          }}
          value={values?.note || ''}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
          disabled={disabled}
        />
      </Grid>
      {hasAttentionNote ? (
        <Grid item xs={12}>
          <Typography color="cdmBrand.main" fontWeight={'bold'} sx={{ textTransform: 'uppercase' }}>
            Attenzione esiste accertamento ancora in carico al servizio messi
          </Typography>
        </Grid>
      ) : undefined}
    </Grid>
  );
};

AccordionRequestAssessmentFormComponent.displayName =
  'Accordion return comunication form component';

const AccordionRequestAssessmentForm = memo(AccordionRequestAssessmentFormComponent);

export default AccordionRequestAssessmentForm;
